import React, { useState } from 'react';

const DriverFilters = ({ filters, handleFilterChange, handleSearchSubmit }) => {
  const [showFilters, setShowFilters] = useState(false);

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSearchSubmit();
    }
  };
  return (
    <div className="card-body pt-2 filters">
      <div
        onClick={() => setShowFilters((prev) => !prev)}
        style={{
          display: 'inline-block',
          cursor: 'pointer',
          color: '#198754',
          fontWeight: 600,
          borderBottom: '2px solid #198754',
          paddingBottom: '2px',
          userSelect: 'none',
          transition: '0.2s ease',
        }}
      >
        Filters
        <i
          className={`fa fa-chevron-${showFilters ? 'up' : 'down'} ml-2`}
          style={{
            fontSize: '12px',
          }}
        />
      </div>

      {showFilters && (
        <div
          className="d-flex flex-column gap-3 mt-3"
          style={{
            animation: 'fadeIn 0.2s ease',
          }}
        >
          <div className="mb-2">
            <input
              className="form-control"
              type="text"
              placeholder="Driver ID"
              value={filters.id || ''}
              onChange={(e) => handleFilterChange(e, 'id')}
              onKeyDown={handleKeyPress}
            />
          </div>

          <div>
            <input
              className="form-control"
              type="text"
              placeholder="Driver name"
              value={filters.name || ''}
              onChange={(e) => handleFilterChange(e, 'name')}
              onKeyDown={handleKeyPress}
            />
          </div>

          <button className="btn btn-primary mt-2" onClick={handleSearchSubmit}>
            Search
          </button>
        </div>
      )}
    </div>
  );
};

export default DriverFilters;
